import { toast } from 'sonner';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiPost, operationsClient } from '@/lib/api';
import { opsEstimateEndpoints } from '@/lib/api/endpoints';
import { estimateKeys } from '@/lib/queryKeys';

/**
 * Rejects / declines an estimate via the operations microservice.
 */
export const useDeleteEstimate = createMutationHook<void, string>({
  mutationFn: (id) => apiPost<void>(operationsClient, opsEstimateEndpoints.reject(id)),
  onSuccess: (_data, id, queryClient) => {
    void queryClient.invalidateQueries({ queryKey: estimateKeys.lists() });
    queryClient.removeQueries({ queryKey: estimateKeys.detail(id) });
    toast.success('Estimate declined');
  },
});
